/* omc-kit-proof v1 - per-piece + most-ordered proof under the Full Kit price */
(function(){
  if (!/\/products\/the-full-kit/.test(location.pathname)) return;
  var PIECES = 4, PRICE = 91.99;
  function money(n){ return '\u00A3' + (Math.round(n*100)/100).toFixed(0); }
  function build(){
    var w = document.createElement('div');
    w.className = 'omc-kitproof';
    var a = document.createElement('p');
    a.className = 'omc-kitproof__math';
    a.innerHTML = '<strong>' + money(PRICE/PIECES) + ' a piece.</strong> Four pieces, one order, done.';
    var b = document.createElement('p');
    b.className = 'omc-kitproof__proof';
    b.innerHTML = '<span class="omc-kitproof__star">\u2605</span> <strong>Most ordered.</strong> 21 of our first 54 orders were the full kit.';
    w.appendChild(a); w.appendChild(b);
    return w;
  }
  function mount(){
    if (document.querySelector('.omc-kitproof')) return true;
    var els = [].slice.call(document.querySelectorAll('product-price'));
    var target = null;
    for (var i=0;i<els.length;i++){
      var r = els[i].getBoundingClientRect();
      if (r.width > 0 && !els[i].closest('.sticky-add-to-cart') && !els[i].closest('.resource-card')) { target = els[i]; break; }
    }
    if (!target || !target.parentNode) return false;
    target.parentNode.insertBefore(build(), target.nextSibling);
    return true;
  }
  function start(){
    if (mount()) return;
    var n = 0;
    var iv = setInterval(function(){ n++; if (mount() || n > 40) clearInterval(iv); }, 150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();